module.exports = __webpack_public_path__ + "images/emoji/space_invader.a8370ba3a645eb8cb4d2.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/space_invader.png
// module id = ySuT
// module chunks = 1